import * as React from 'react';
import WPhoto from '../../WPhotoBase';
import { SkinWPhotoProps } from '../SkinWPhoto';
import { BaseWPhotoSkinProps } from '../../../WPhoto.types';
import skinsStyles from './styles/LiftedTopPhoto.scss';
import BasicWPhotoSkin from './BasicWPhotoSkin';

const LiftedTopPhotoSkin: React.FC<Omit<
  BaseWPhotoSkinProps,
  'skinsStyle'
>> = props => <BasicWPhotoSkin {...props} skinsStyle={skinsStyles} />;

const LiftedTopPhoto: React.FC<SkinWPhotoProps> = props => (
  <WPhoto {...props} skin={LiftedTopPhotoSkin} />
);

export default LiftedTopPhoto;
